<template>
	<div class="auth-bg" :class="{ 'auth-bg--dimmed': dimmed }">
		<div class="auth-bg__base"></div>
		<div class="auth-bg__glows"></div>
		<div class="auth-bg__panels"></div>
		<div class="auth-bg__dots"></div>
	</div>
</template>

<script>
export default {
	name: 'AuthBackground',
	props: {
		dimmed: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped lang="scss">
.auth-bg {
	position: absolute;
	inset: 0;
	pointer-events: none;
}

.auth-bg__base,
.auth-bg__glows,
.auth-bg__panels,
.auth-bg__dots {
	position: absolute;
	inset: 0;
	pointer-events: none;
}

.auth-bg__base {
	background: linear-gradient(135deg, #f3f7ff 0%, #f5f3fc 100%);
}

.auth-bg__glows {
	background-image:
		radial-gradient(ellipse 70% 50% at 85% 15%, rgba(65, 105, 222, 0.08) 0%, transparent 55%),
		radial-gradient(ellipse 60% 45% at 10% 75%, rgba(103, 68, 184, 0.06) 0%, transparent 50%),
		radial-gradient(ellipse 50% 40% at 50% 50%, rgba(255, 255, 255, 0.4) 0%, transparent 45%);
}

.auth-bg__dots {
	opacity: 0.4;
	background-image: radial-gradient(circle, rgba(65, 105, 222, 0.16) 1px, transparent 1px);
	background-size: 24px 24px;
}

.auth-bg__panels {
	opacity: 0.5;
	background-image:
		repeating-linear-gradient(115deg,
			transparent 0,
			transparent 60px,
			rgba(65, 105, 222, 0.04) 60px,
			rgba(65, 105, 222, 0.04) 65px),
		repeating-linear-gradient(25deg,
			transparent 0,
			transparent 90px,
			rgba(103, 68, 184, 0.04) 90px,
			rgba(103, 68, 184, 0.04) 95px);
}

.auth-bg--dimmed {

	.auth-bg__base,
	.auth-bg__glows,
	.auth-bg__panels,
	.auth-bg__dots {
		opacity: 0.5;
	}
}
</style>
